import React, { useEffect, useState } from 'react';
import { Create_Api, Update_Api } from '../../API_URL';
import { toast } from 'react-toastify';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';

function NewsLetter() {
  const navigate = useNavigate()
  const [isUploading, setIsUploading] = useState(false);
  const [Email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [Name, setName] = useState('');
  const [Organization, setOrganization] = useState('');
  const [Designation, setDesignation] = useState('');
  const [ModelOpen, setModelOpen] = useState(false);

  const OpenModel = () => {
    setModelOpen(true)
  }
  const CloseModel = () => {
    setModelOpen(false)
  }

  useEffect(() => {
    Aos.init({ once: true });
  }, []);


  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!Email.trim()) newErrors.Email = 'Email is required';
    else if (!emailRegex.test(Email.trim()))
      newErrors.Email = 'Please enter a valid email address';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!Email) return toast.error('Email is required')
    if (!Name) return toast.error('Name is required')
    if (!Organization) return toast.error('Organization is required')
    if (!Designation) return toast.error('Designation is required')

    try {
      setIsUploading(true);
      const data = {
        Email,
        Name,
        Organization,
        Designation
      };
      const response = await Create_Api('api/admin/AddNewsletter', data);
      if (response.statusCode == 200) {
        toast.success('DOT Weekly Subscribed successfully.');
        CloseModel()
        setEmail('');
        setName('');
        setOrganization('');
        setDesignation('');
        CloseModel()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Error creating Category.');
      console.error('Error creating Category:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>

      <div
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-easing="ease-out-cubic"

        className="max-w-[1440px] w-[100%] lg:w-full bg-[#FFFFFF] rounded-[20px] lg:rounded-[30px] py-[50px] lg:py-[53px] px-[20px] lg:px-[70px] mx-auto my-[60px] flex flex-col items-start"
        style={{
          boxShadow: "0px 10px 100px 0px #89A1A82B",
          backgroundImage: `url('/assets/home/whiteearth.jpg')`,
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <h6
          data-aos="fade-right"
          data-aos-delay="200"
          className="pb-[10px] lg:pb-[10px] font-neue font-[400] text-[22px] sm:text-[28px] lg:text-[36px] leading-[32px] sm:leading-[40px] lg:leading-[52px] text-left text-[#0F3460]"
        >
          Subscribe to DOT Weekly
          <span className="text-[#BB872A]"></span>
        </h6>
        <p
          data-aos="fade-right"
          data-aos-delay="400"
          className="text-left font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[20px] lg:pb-[31px] max-w-[700px]"
        >
        DOT Weekly is our brief on U.S.-India defense, operations, and technology. Each issue covers the week's deals, procurement, and policy from primary sources. Its readers span government, industry, and investment in Washington, Delhi, and beyond.
        </p>

        <div
          data-aos="fade-up"
          data-aos-delay="600"
          className="max-w-[450px] w-full flex flex-col lg:flex-row gap-[15px] lg:gap-0 justify-between items-start pb-[10px] border-b border-[#2E4D7380]"
        >
          {/* <div className="flex gap-[10px] items-center w-full lg:w-auto">
            <img src="/assets/home/mail.svg" alt="mail" className="w-[18px] h-[18px] lg:w-auto lg:h-auto" />
            <input
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              className="w-full font-neue text-[15px] sm:text-[16px] text-[#0F3460] bg-transparent outline-none border-none placeholder:text-[#94A3B8]"
              placeholder="Your Email Address"
            />
          </div> */}

          <button
            // onClick={() => OpenModel()}
            onClick={() => navigate('/subscription')}
            style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
            className="w-full lg:w-auto mt-[15px] lg:mt-0 py-[10px] lg:py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[10px] lg:rounded-[12px] font-[400] font-neue text-[13px] sm:text-[14px] leading-[20px] text-center text-[#FFFFFF]"
          >
            Subscribe to DOT Weekly
          </button>
        </div>
        <p
          data-aos="fade-right"
          data-aos-delay="400"
          className="text-left font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[20px] lg:pb-[31px] max-w-[700px]"
        >
          Written for senior readers in both countries.
        </p>
      </div>

      {ModelOpen && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 px-[15px] sm:px-[20px]">
          <div
            className=" w-full  max-w-[500px] bg-white  rounded-t-[20px] sm:rounded-[20px]  p-[20px] sm:p-[25px] lg:p-[35px]  max-h-[90vh]  overflow-y-auto "
            style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
          >
            <h2 className="text-[18px] sm:text-[22px] lg:text-[26px] font-neue text-[#0F3460] mb-[20px]">
              DOT Weekly subscription
            </h2>
            <div className="mb-[15px]">
              <input
                type="text"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email"
                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
              />
            </div>
            <div className="mb-[15px]">
              <input
                type="text"
                value={Name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your Name"
                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
              />
            </div>
            <div className="mb-[15px]">
              <input
                type="text"
                value={Designation}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Your Designation"
                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
              />
            </div>
            <div className="mb-[25px]">
              <input
                type="text"
                value={Organization}
                onChange={(e) => setOrganization(e.target.value)}
                placeholder="Your Organization"
                className="font-neue text-[14px] w-full sm:text-[16px] md:text-[14px] font-[400] py-[10px] sm:py-[10px] px-[18px] sm:px-[23px] rounded-[10px] border border-[#0922101A] text-[#092210B2]"
              />
            </div>
            <div className="flex justify-center w-full">
              {/* <button
                onClick={(e) => handleSubmit(e)}
                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                className="w-full max-w-[400px] mt-[15px] py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] leading-[20px] text-center text-[#FFFFFF]"
              >
                {isUploading ? "Please wait..." : "Subscribe"}
              </button> */}
              <button
                onClick={(e) => handleSubmit(e)}
                disabled={isUploading}
                style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                className={`w-full max-w-[400px] mt-[15px] py-[12px] px-[15px] transition-all duration-500 
    border border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue 
    text-[14px] leading-[20px] text-center text-[#FFFFFF]
    ${isUploading ? "opacity-50 cursor-not-allowed" : "hover:bg-transparent hover:text-[#BB872A] hover:border-[#BB872A]"}`}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      )}


    </>

  );
}

export default NewsLetter;
